import React from 'react';
export function ComparisonTable() {
  return <div className="mb-16" data-id="element-58">
      <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-59">
        📊 At-a-Glance Comparison: UK's Top 5 Elbow Braces for Padel
      </h2>
      <div className="overflow-x-auto" data-id="element-60">
        <table className="w-full border-collapse bg-white shadow-sm rounded-lg overflow-hidden" data-id="element-61">
          <thead className="bg-green-600 text-white" data-id="element-62">
            <tr data-id="element-63">
              <th className="p-4 text-left font-semibold" data-id="element-64">Brand</th>
              <th className="p-4 text-left font-semibold" data-id="element-65">Brace Type</th>
              <th className="p-4 text-left font-semibold" data-id="element-66">Key Technology</th>
              <th className="p-4 text-center font-semibold" data-id="element-67">Padel-Specific</th>
              <th className="p-4 text-center font-semibold" data-id="element-68">
                Stability Rating
              </th>
              <th className="p-4 text-left font-semibold" data-id="element-69">Price</th>
              <th className="p-4 text-center font-semibold" data-id="element-70">Our Score</th>
            </tr>
          </thead>
          <tbody data-id="element-71">
            <tr className="border-b border-gray-200 bg-green-50" data-id="element-72">
              <td className="p-4 font-semibold" data-id="element-73">PadelGuard</td>
              <td className="p-4" data-id="element-74">Counter-force strap</td>
              <td className="p-4" data-id="element-75">Five-point pad + BOA® dial</td>
              <td className="p-4 text-center" data-id="element-76">✅ Yes</td>
              <td className="p-4 text-center" data-id="element-77">⭐⭐⭐⭐⭐</td>
              <td className="p-4 font-semibold" data-id="element-78">£29</td>
              <td className="p-4 text-center font-bold text-green-600" data-id="element-79">
                96/100
              </td>
            </tr>
            <tr className="border-b border-gray-200" data-id="element-80">
              <td className="p-4 font-semibold" data-id="element-81">Bauerfeind Sports</td>
              <td className="p-4" data-id="element-82">Counter-force strap</td>
              <td className="p-4" data-id="element-83">BOA® dial + premium pad</td>
              <td className="p-4 text-center" data-id="element-84">⚠️ Partial</td>
              <td className="p-4 text-center" data-id="element-85">⭐⭐⭐⭐☆</td>
              <td className="p-4" data-id="element-86">£45</td>
              <td className="p-4 text-center font-semibold" data-id="element-87">87/100</td>
            </tr>
            <tr className="border-b border-gray-200" data-id="element-88">
              <td className="p-4 font-semibold" data-id="element-89">PODO Lyon</td>
              <td className="p-4" data-id="element-90">Compression sleeve</td>
              <td className="p-4" data-id="element-91">Dual silicone pads</td>
              <td className="p-4 text-center" data-id="element-92">⚠️ Partial</td>
              <td className="p-4 text-center" data-id="element-93">⭐⭐⭐⭐☆</td>
              <td className="p-4" data-id="element-94">£35-40</td>
              <td className="p-4 text-center font-semibold" data-id="element-95">83/100</td>
            </tr>
            <tr className="border-b border-gray-200" data-id="element-96">
              <td className="p-4 font-semibold" data-id="element-97">Bauerfeind Five-Point</td>
              <td className="p-4" data-id="element-98">Counter-force strap</td>
              <td className="p-4" data-id="element-99">Five-point pressure pad</td>
              <td className="p-4 text-center" data-id="element-100">⚠️ Partial</td>
              <td className="p-4 text-center" data-id="element-101">⭐⭐⭐⭐☆</td>
              <td className="p-4" data-id="element-102">£49.95</td>
              <td className="p-4 text-center font-semibold" data-id="element-103">78/100</td>
            </tr>
            <tr data-id="element-104">
              <td className="p-4 font-semibold" data-id="element-105">4DflexiSPORT</td>
              <td className="p-4" data-id="element-106">Dual-strap</td>
              <td className="p-4" data-id="element-107">Basic foam pad</td>
              <td className="p-4 text-center" data-id="element-108">❌ No</td>
              <td className="p-4 text-center" data-id="element-109">⭐⭐⭐☆☆</td>
              <td className="p-4" data-id="element-110">£12-15</td>
              <td className="p-4 text-center font-semibold" data-id="element-111">76/100</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}